import Instance from "../../../Axios";

const GetAdesaoFilesCompExcById = (id) => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/${id}/filesCompExc`)
    .then(({ data }) => {
      dispatch({ type: "GET_ADESAO_FILES_COMP_EXC_BY_ID", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAdesaoFilesCompExcById;